import React, { useEffect, useState } from 'react';
import { CHART_CONST } from '../../../common/constant/page-constants';
import { BUNDLES_OPTION, CHART_OPTIONS, getBundlesParamList, getParameterList } from '../../../common/constant/common-constants';
import './BundlesContainer.scss'
import { getBundlesChart, updateBundlesChart } from '../../../helper/chart-helper';
import { components } from 'react-select';
import moment from 'moment';
import { checkIfBedIdContainsSession } from '../../../common/utils/CommonUtils';

function BundlesContainer(props) {

    const [bundleOptionActive, setBundleOptionActive] = useState(BUNDLES_OPTION.VAP);
    const [bundleOptionHeading, setBundleOptionHeading] = useState(props && props.parameterList && props.parameterList[0].heading);
    const [headerList, setHeaderList] = useState(props.headerList);
    const [parameterList, setParameterList] = useState(props.parameterList);
    const [vapTempData, setVapTempData] = useState("");
    const [cautiTempData, setCautiTempData] = useState("");
    const [clabsiTempData, setClabsiTempData] = useState("");
    const [selectedBundleTableParam, setSelectedBundleTableParam] = useState('');

    useEffect(() => {
        setHeaderList([...props.headerList]);
        setParameterList([...props.parameterList]);
    }, [props]);

    useEffect(() => {
        getBundleDataHandler(BUNDLES_OPTION.VAP);
        getBundleDataHandler(BUNDLES_OPTION.CLABSI);
        getBundleDataHandler(BUNDLES_OPTION.CAUTI);

    }, [])

    useEffect(() => {
        getBundleDataHandler(BUNDLES_OPTION.VAP);
        getBundleDataHandler(BUNDLES_OPTION.CLABSI);
        getBundleDataHandler(BUNDLES_OPTION.CAUTI);

    }, [props.data.prescriptionDate])

    const getBundleDataHandler = (option) => {
        let data = {
            type: option,
            bedId: checkIfBedIdContainsSession(props.data.bedId),
            patientSessionId: props.data.patientSessionId,
            date: moment(props.data.prescriptionDate).format("YYYY-MM-DD"),
        }
        getBundlesChart(data).then((res) => {
            // console.log("res from api", res);
            if (option === BUNDLES_OPTION.VAP)
                setVapTempData(res);
            if (option === BUNDLES_OPTION.CAUTI)
                setCautiTempData(res);
            if (option === BUNDLES_OPTION.CLABSI)
                setClabsiTempData(res);

        }).catch((err) => {
            console.log(err)
        });
    }

    useEffect(() => {
        setSelectedBundleTableParam(getBundlesParamList(bundleOptionActive));
    }, [bundleOptionActive]);

    useEffect(() => {
        if (props.updateBundlesData) {
            updateBundleDataHandler(BUNDLES_OPTION.VAP);
            updateBundleDataHandler(BUNDLES_OPTION.CAUTI);
            updateBundleDataHandler(BUNDLES_OPTION.CLABSI);
        }
    }, [props.updateBundlesData])

    const updateBundleDataHandler = (option) => {

        let data
        if (option === BUNDLES_OPTION.VAP) {
            data = { ...vapTempData, type: option };
        } else if (option === BUNDLES_OPTION.CAUTI) {
            data = { ...cautiTempData, type: option };
        } else if (option === BUNDLES_OPTION.CLABSI) {
            data = { ...clabsiTempData, type: option };
        }
        console.log("data going for updation", data);
        updateBundlesChart(data).then((res) => {
            console.log("update res", res);
            if (option === BUNDLES_OPTION.VAP)
                setVapTempData(res);
            if (option === BUNDLES_OPTION.CAUTI)
                setCautiTempData(res);
            if (option === BUNDLES_OPTION.CLABSI)
                setClabsiTempData(res);
        }).catch((err) => {
            console.log("updation err", err);
        })
        props.setUpdateBundlesData(false);
    }

    const handleBundleSelectOption = (option) => {
        // console.log("VAP::", vapTempData, "CAUTI", cautiTempData, "CLABSI", clabsiTempData);
        setBundleOptionActive(option.name);
        setBundleOptionHeading(option.heading);
    }

    const handleChange = (type, id, key, event) => {
        console.log("type", type, "id", id, "key", key, "event", event.target.value)
        let header = id;
        if (headerList.indexOf(id) > -1) {
            header = id;
            id = CHART_CONST.NEW_ID_PRED + id;
        }
        let value = event && event.target && event.target.value;

        if (value === "on") value = event.target.checked;

        if (value === undefined) return;

        let dataList;
        if (bundleOptionActive === BUNDLES_OPTION.VAP)
            dataList = vapTempData.data;
        if (bundleOptionActive === BUNDLES_OPTION.CAUTI)
            dataList = cautiTempData.data;
        if (bundleOptionActive === BUNDLES_OPTION.CLABSI)
            dataList = clabsiTempData.data;
        // console.log("dataList in bundles", dataList);

        const col = dataList && dataList.length > 0 && dataList.filter((obj) => obj.id === id)[0];

        // console.log("col in bundles", col);
        value = (value === "") ? null : value;
        if (col) {
            col[key] = value;
        } else {
            let change = {
                [key]: value,
            }
            let tempData = {
                "id": id,
                "time": header,
                "isUpdated": false,
            }
            tempData["shift"] = header;
            tempData = {
                ...tempData,
                ...change
            }

            dataList && dataList.push(tempData);
        }
    }

    // const handleIsApplicable = (event) => {
    //     let dataList;
    //     if (bundleOptionActive === BUNDLES_OPTION.VAP)
    //         dataList = vapTempData;
    //     if (bundleOptionActive === BUNDLES_OPTION.CAUTI)
    //         dataList = cautiTempData;
    //     if (bundleOptionActive === BUNDLES_OPTION.CLABSI)
    //         dataList = clabsiTempData;

    //     console.log(event.target.id.split("-")[1]);
    //     event.target.id.split("-")[1] === "yes" ? dataList['isApplicable'] = true : dataList['isApplicable'] = false;
    //     console.log("dataList in isaPllicable", dataList);
    // }

    // const handleValueisApplicable = (radio) => {

    //     if (bundleOptionActive === BUNDLES_OPTION.VAP && vapTempData) {
    //         if (radio === "yes") return (vapTempData['isApplicable'] === true);
    //         else return (vapTempData['isApplicable'] === false)

    //     } else if (bundleOptionActive === BUNDLES_OPTION.CAUTI && cautiTempData) {
    //         if (radio === "yes") return (cautiTempData['isApplicable'] === true);
    //         else return (cautiTempData['isApplicable'] === false);

    //     } else if (bundleOptionActive === BUNDLES_OPTION.CLABSI && clabsiTempData) {
    //         if (radio === "yes") return (clabsiTempData['isApplicable'] === true);
    //         else return (clabsiTempData['isApplicable'] === false)
    //     }
    // }
    const getBundlesTableHtml = () => {
        let html = headerList && headerList.map((header, count) => {

            /* for rendering parameters in first column */
            if (count === 0) {
                return (
                    <div className="column parameters" key={count}>
                        <div className="cell heading param-nursing">{header}</div>
                        {selectedBundleTableParam && selectedBundleTableParam.map((param) => {
                            return (<div className="cell body param-nursing" key={param.label}>{param.label}</div>)
                        })}
                    </div>);
            } else {
                /** rendering data from the data array **/
                let col;
                if (bundleOptionActive === BUNDLES_OPTION.VAP) col = vapTempData && vapTempData.data && vapTempData.data.length > 0 && vapTempData.data.filter((obj) => obj.shift === header)[0];
                if (bundleOptionActive === BUNDLES_OPTION.CAUTI) col = cautiTempData && cautiTempData.data && cautiTempData.data.length > 0 && cautiTempData.data.filter((obj) => obj.shift === header)[0];
                if (bundleOptionActive === BUNDLES_OPTION.CLABSI) col = clabsiTempData && clabsiTempData.data && clabsiTempData.data.length > 0 && clabsiTempData.data.filter((obj) => obj.shift === header)[0];
                if (col) {
                    return (<div className="column" key={count}>
                        <div className="cell heading">{header}</div>
                        {selectedBundleTableParam && selectedBundleTableParam.map((param) => {
                            if (param.type === "checkbox") {
                                return (
                                    <div className="cell body" key={param.label}>
                                        <input
                                            className={col["isUpdated"] || !props.isEditable ? "chart-checkbox disabled" : "chart-checkbox"}
                                            checked={col[param.name]}
                                            type="checkbox"
                                            aria-disabled={col["isUpdated"] || !props.isEditable}
                                            onChange={(event) => handleChange(CHART_CONST.UPDATE, col["id"], param.name, event)}
                                        />
                                    </div>);
                            }
                        })}
                    </div>);
                } else {
                    return (<div className="column" key={count}>
                        <div className="cell heading">{header}</div>
                        {
                            selectedBundleTableParam && selectedBundleTableParam.map((param, count) => {
                                if (param.type === "checkbox") {
                                    return (<div className="cell body" key={param.name} >
                                        <input
                                            type="checkbox"
                                            className="chart-checkbox"
                                            aria-disabled={!props.isEditable ? true : false}
                                            onChange={(event) => handleChange(CHART_CONST.ADD, header, param.name, event)} />
                                    </div>);
                                }
                            })
                        }
                    </div >);
                }
            }
        });
        return html;
    }

    return (
        <div className='bundles-container'>
            <div className='bundles-heading'>Bundles</div>
            <div className='body-panels'>
                <div className='bundles-left-panel'>
                    {parameterList.map((param, count) => {
                        return (<div className={bundleOptionActive === param.name ? 'left-panel-option selected' : 'left-panel-option'} key={count} onClick={() => handleBundleSelectOption(param)}>
                            {param.name}
                        </div>)
                    })}

                </div>
                <div className='bundles-right-panel'>
                    <div className='bundles-option-heading'>
                        {bundleOptionHeading}
                        {/* <div className='applicable-yes-no'>
                            <span>Applicable?</span>
                            <div>
                                <input
                                    type='radio'
                                    id={`applicable-yes`}
                                    name='applicable-bundle'
                                    className='app-checkbox'
                                    value={() => handleValueisApplicable("yes")
                                    }
                                    onChange={(event) => {
                                        console.log("event in input", event)
                                        handleIsApplicable(event);
                                    }}
                                />
                                <label htmlFor='applicable-yes' >Yes</label>
                            </div>
                            <div>
                                <input
                                    type='radio'
                                    id={`applicable-no`}
                                    name='applicable-bundle'
                                    className='app-checkbox'
                                    value={() => handleValueisApplicable("no")
                                    }
                                    onChange={(event) => {
                                        console.log("event in input", event);
                                        handleIsApplicable(event);
                                    }}
                                />
                                <label htmlFor='applicable-no' >No</label>
                            </div>
                        </div> */}

                    </div>
                    <div className='right-panel-table'>
                        {getBundlesTableHtml()}
                    </div>
                </div>
            </div>

        </div>
    );
}

export default BundlesContainer;